export enum PregnantAndNewbornInsuranceType {
  NEWBORN = "newborn",
  PREGNANT = "pregnant",
}
